import { updateApiData } from "../../../utils/utils";

export const requestParentalPinReset = async (appInfo, email) => {
  const api = "user/parentalPin/reset/send";
  const location = {
    path: "common",
    values: {
      user_email: email,
    },
  };

  return await updateApiData(appInfo, api, location);
};

export const verifyParentalPinReset = async (appInfo, token, expiresIn) => {
  const api = "user/parentalPin/reset/verify";
  const location = {
    path: "common",
    values: {
      token,
      expires_in: expiresIn,
    },
  };

  return await updateApiData(appInfo, api, location);
};

export const confirmParentalPinReset = async (appInfo, requestId, newPin) => {
  const api = "user/parentalPin/reset/confirm";
  const location = {
    path: "common",
    values: {
      id: requestId,
      new_pin: newPin,
    },
  };

  return await updateApiData(appInfo, api, location);
};
